import React, {useRef} from "react";
import {useTranslation} from "react-i18next";
import {KatButton, KatInput, KatLabel, KatModal} from "@amzn/katal-react";
import {IOperation, ISectionItem} from "src/context/models/Section";

export type IOperationSearchModalProps = {
    setVisible: (visible: boolean) => void;
    sections: ISectionItem[];
    alarmName?: string;
};

interface ISectionOperationPair {
    section: string;
    operation: string;
}

export const OperationSearchModal: React.FC<IOperationSearchModalProps> = ({
                                                                               setVisible,
                                                                               sections,
                                                                               alarmName
                                                                           }) => {
    const {t} = useTranslation();
    const alarmNameInput: React.RefObject<KatInput.Element> = useRef<KatInput.Element>(null);
    const [section, setSection] = React.useState("");
    const [operation, setOperation] = React.useState("");
    const [error, setError] = React.useState("");

    const populateMap = (sections: ISectionItem[]) => {
        const operationMap: Map<string, ISectionOperationPair> = new Map();
        sections.forEach(section => {
            Object.keys(section.versions).forEach((version) => {
                // @ts-ignore
                const operations: IOperation[] = section.versions[version] as IOperation[];
                operations.forEach((operation) => {
                    const value: ISectionOperationPair = {section: section.name, operation: operation.operationId};
                    operationMap.set(operation.path, value);
                });
            });
        });
        return operationMap;
    }

    const updateErrorMessage = (errorMessage:string) => {
        console.error(errorMessage, alarmNameInput.current?.value);
        setError(errorMessage);
        setSection("");
        setOperation("");
    }

    const findOperation = () => {
        if (!alarmNameInput.current?.value || alarmNameInput.current?.value.split('|').length != 12) {
            let errorMessage: string = "Invalid inputs. Please verify alarm name."
            updateErrorMessage(errorMessage);
            return;
        }
        const operationPath: string = (alarmNameInput.current?.value.split('|')[7] as string).substr(1);
        if (!operationPathToIdMap.has(operationPath)) {
            let errorMessage: string = "No operation with the given operation path found."
            updateErrorMessage(errorMessage);
            return;
        }
        const pair: ISectionOperationPair = operationPathToIdMap
            .get(operationPath) as ISectionOperationPair;
        setSection(pair.section);
        setOperation(pair.operation);
        setError("");
    }

    const handleClose = () => {
        setVisible(false);
    }

    const operationPathToIdMap = populateMap(sections);

    return (
        <KatModal className="event-modal"
                  visible={true}
                  onClose={() => handleClose()}>
            <span slot="title">{t("Search for Section-Operation")}</span>
            <KatInput
                ref={alarmNameInput}
                label={t("Alarm Name")}
                type="text"
                value={alarmName}
            />
            <div className="spacer-small"/>
            {error ? <KatLabel
                emphasis={t("Error:")}
                text={error}
                state="error"
                variant="constraint"
            /> : null}
            <div className="spacer-small"/>
            <KatLabel
                emphasis={t("Section")}
                text={section}
            />
            <div className="spacer-xxsmall"/>
            <KatLabel
                emphasis={t("Operation")}
                text={operation}
            />
            <div slot="footer">
                <KatButton
                    className="submit-button"
                    label={t("Search")}
                    onClick={() => findOperation()}
                />
            </div>
        </KatModal>
    );
}